export default "__VITE_ASSET__bMIFd0Ve__"